import U from './lib-utils'

function unit() {
  return (unit.is(this) ? this.init : unit.F).apply(
    this,
    Array.prototype.slice.call(arguments),
  )
}

var UP = U.fixup_constructor(unit).prototype

UP.domain = null
UP.id = null
UP.name = null
UP.ks = 0
UP.si = false

UP.init = function (domain, desc) {
  var io = U.safeObject(desc)
  this.domain = U.NEString(U.NEString(domain, '').toLowerCase(), null)
  this.id = U.NEString(U.NEString(io.id, '').toLowerCase(), null)
  this.name = U.NEString(U.NEString(io.name, '').toLowerCase(), null)
  this.si = U.any_bool(io.si, false)
  this.ks = U.FloatMoreOr(io.ks, 0, null)
  return this
}
UP.isValid = function () {
  return !!(
    null !== this.domain &&
    null !== this.id &&
    null !== this.name &&
    U.isNumber(this.ks) &&
    this.ks > 0
  )
}

function domain() {
  return (domain.is(this) ? this.init : domain.F).apply(
    this,
    Array.prototype.slice.call(arguments),
  )
}

var DP = U.fixup_constructor(domain).prototype
DP.units = null
DP.domain = null
DP.indexedUnits = null

DP.init = function (name, units) {
  this.domain = U.NEString(U.NEString(name, '').toLowerCase(), null)
  this.units = []
  this.indexedUnits = {}
  var rawUnits = U.safe_array(units)
  for (var i = 0; i < rawUnits.length; i++) {
    var lUnit = unit(this.domain, rawUnits[i])
    if (lUnit.isValid()) {
      if (Object.prototype.hasOwnProperty.call(this.indexedUnits, lUnit.id)) {
        throw new Error(
          [
            'unit with id `',
            lUnit.id,
            '` alredy contains in domain `',
            this.domain,
            '`',
          ].join(''),
        )
      }
      this.units.push(lUnit)
      this.indexedUnits[lUnit.id] = lUnit
    }
  }
  return this
}

DP.isValid = function () {
  return !!(null !== this.domain && this.units.length)
}

DP.getUnitById = function (id) {
  var sid = U.NEString(U.NEString(id, '').toLowerCase(), null)
  if (null !== sid) {
    if (unit.is(this.indexedUnits[sid])) {
      return this.indexedUnits[sid]
    }
  }
  return null
}
DP.get = DP.getUnitById
DP.getUnit = DP.get
DP.get_unit = DP.get
DP.get_unit_by_id = DP.get

DP.getDefaultUnit = function () {
  for (var i = 0; i < this.units.length; i++) {
    if (true === this.units[i].si) {
      return this.units[i]
    }
  }
  return null
}

DP.get_default = DP.getDefaultUnit
DP.getDefault = DP.get_default

DP.convertUnit = function (pFrom, pTo, value) {
  if (pFrom instanceof String) {
    pFrom = this.get_unit(pFrom)
  }
  if (pTo instanceof String) {
    pTo = this.get_unit(pTo)
  }
  if (!U.isNumber(value)) {
    value = U.floatOr(value, null)
  }
  if (unit.is(pFrom) && unit.is(pTo) && U.isNumber(value)) {
    if (pFrom.domain === pTo.domain) {
      if (pFrom.domain === this.domain) {
        var dUnit = this.getDefault()
        if (dUnit) {
          //default unit is not obligate - but required for metric checking
          var valueInDefaultUnit = value * pFrom.ks
          return valueInDefaultUnit / pTo.ks
        } else {
          throw new Error(
            [
              'domain `',
              this.domain,
              '` does not contain `default` (si) unit',
            ].join(''),
          )
        }
      } else {
        throw new Error(
          [
            'domain `',
            this.domain,
            '` can`t convert units in domain `',
            pFrom.domain,
            '`',
          ].join(''),
        )
      }
    } else {
      throw new Error('convertUnit requires units in same domain')
    }
  } else {
    throw new Error('convertUnit accepts (unitFrom,unitTo,value) args')
  }
}

DP.convert_unit = DP.convertUnit
DP.convert = DP.convert_unit

DP.convertToDefault = function (pFrom, value) {
  if (pFrom instanceof String) {
    pFrom = this.get_unit(pFrom)
  }
  if (!U.isNumber(value)) {
    value = U.floatOr(value, null)
  }
  if (unit.is(pFrom) && U.isNumber(value)) {
    if (pFrom.domain === this.domain) {
      var dUnit = this.getDefault()
      if (dUnit) {
        return value * pFrom.ks
      } else {
        throw new Error(
          [
            'domain `',
            this.domain,
            '` does not contain `default` (si) unit',
          ].join(''),
        )
      }
    } else {
      throw new Error(
        [
          'domain `',
          this.domain,
          '` can`t convert units in domain `',
          pFrom.domain,
          '`',
        ].join(''),
      )
    }
  } else {
    throw new Error('convertToDefault accepts (unitFrom,value) args')
  }
}
DP.convertDefault = DP.convertToDefault
DP.convert_to_default = DP.convertToDefault
DP.convert_default = DP.convert_to_default
DP.toSI = DP.convert_to_default
DP.to_si = DP.toSI

DP.listUnits = function (filterFunc) {
  var units = []
  if (U.is_callable(filterFunc)) {
    for (var i = 0; i < this.units.length; i++) {
      if (true === filterFunc(this.units[i])) {
        units.push(this.units[i])
      }
    }
  } else {
    units = units.concat(this.units)
  }

  return units
}

DP.list = DP.listUnits
DP.list_units = DP.list

function initialize() {
  this.domains['linear'] = domain('linear', [
    {
      id: 'mm',
      si: false,
      ks: 0.001,
      name: 'millimeter',
    },
    {
      id: 'cm',
      si: false,
      ks: 0.01,
      name: 'centimeter',
    },
    {
      id: 'sm',
      si: false,
      ks: 0.01,
      name: 'centimeter',
    },
    {
      id: 'm',
      si: true,
      ks: 1.0,
      name: 'meter',
    },
    {
      id: 'km',
      si: false,
      ks: 1000,
      name: 'kilometer',
    },
  ])

  this.domains['weight'] = domain('weight', [
    {
      id: 'g',
      si: false,
      ks: 0.001,
      name: 'gramm',
    },
    {
      id: 'kg',
      si: true,
      ks: 1.0,
      name: 'kilogramm',
    },
    {
      id: 'q',
      si: false,
      ks: 100,
      name: 'metric centner',
    },
    {
      id: 't',
      si: false,
      ks: 1000,
      name: 'tonn',
    },
  ])
}

var H = null
function unitConverter() {
  return unitConverter.is(H)
    ? H
    : (unitConverter.is(this) ? this.init : unitConverter.F).apply(
        this,
        Array.prototype.slice.call(arguments),
      )
}

var CP = U.fixup_constructor(unitConverter).prototype
CP.domains = null
CP.init = function () {
  H = this
  this.domains = {}
  initialize.call(this)
  return this
}

CP.getDomain = function (pDomain) {
  var dn = U.NEString(U.NEString(pDomain, '').toLowerCase(), null)
  if (dn) {
    if (domain.is(this.domains[dn])) {
      return this.domains[dn]
    }
  }
  return null
}

CP.get_domain = CP.getDomain
CP.domain = CP.get_domain

export default unitConverter
